import config from '../../config';

class RegisterService {
  async register(userDto) {
    try {
      const response = await fetch(`${config.apiUrl}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userDto),
      });

      if (!response.ok) {
        const error = await response.json();
        return error;
      }

      const data = await response.json();
      return {token: data.token, refreshToken: data.refreshToken};
    } catch (error) {
      console.error('Register error:', error);
      throw error;
    }
  }
}
  
  export default new RegisterService();